import { render, staticRenderFns } from "./AccordionFilters.vue?vue&type=template&id=53f9a4a5&scoped=true"
import script from "./AccordionFilters.vue?vue&type=script&lang=js"
export * from "./AccordionFilters.vue?vue&type=script&lang=js"
import style0 from "./AccordionFilters.vue?vue&type=style&index=0&id=53f9a4a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f9a4a5",
  null
  
)

export default component.exports